import { CSSProperties, ReactNode } from "react"

export enum TextColor {
  Green = "green",
  DarkGreen = "dark-green",
  Blue = "blue",
  DarkBlue = "dark-blue",
  Black = "black",
  White = "white",
}

export const TextColorMap = {
  [TextColor.Black]: "text-igem-black",
  [TextColor.DarkBlue]: "text-igem-dark-blue",
  [TextColor.DarkGreen]: "text-igem-dark-green",
  [TextColor.Green]: "text-igem-green",
  [TextColor.Blue]: "text-igem-blue",
  [TextColor.White]: "text-white",
}

export enum TextWeight {
  Light = "light", // 300
  Regular = "normal", // 400
  Medium = "medium", // 500
  Semibold = "semibold", // 600
  Bold = "bold", // 700
}

export const TextWeightMap = {
  [TextWeight.Light]: "font-light",
  [TextWeight.Regular]: "font-normal",
  [TextWeight.Medium]: "font-medium",
  [TextWeight.Semibold]: "font-semibold",
  [TextWeight.Bold]: "font-bold",
}

export enum TextSpace {
  None = "none",
  S = "small",
  M = "medium",
  L = "large",
}

export const PaddingLeftMap = {
  [TextSpace.None]: "",
  [TextSpace.S]: "pl-4",
  [TextSpace.M]: "pl-8",
  [TextSpace.L]: "pl-12",
}

export const PaddingRightMap = {
  [TextSpace.None]: "",
  [TextSpace.S]: "pr-4",
  [TextSpace.M]: "pr-8",
  [TextSpace.L]: "pr-12",
}

export const MarginLeftMap = {
  [TextSpace.None]: "",
  [TextSpace.S]: "ml-4",
  [TextSpace.M]: "ml-8",
  [TextSpace.L]: "ml-12",
}

export const MarginRightMap = {
  [TextSpace.None]: "",
  [TextSpace.S]: "mr-4",
  [TextSpace.M]: "mr-8",
  [TextSpace.L]: "mr-12",
}

export interface ITextProps {
  children: ReactNode
  color?: TextColor
  weight?: TextWeight
  marginLeft?: TextSpace
  marginRight?: TextSpace
  paddingLeft?: TextSpace
  paddingRight?: TextSpace
  style?: CSSProperties
}
